import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=2359f2cb&"
import script from "./BaseUpload.vue?vue&type=script&lang=js&"
export * from "./BaseUpload.vue?vue&type=script&lang=js&"
import style0 from "./BaseUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports